import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      redirect: '/index' /* hpp将index改称为了login */
    },
    {
      path: '/index',
      name: '首页',
      component: resolve => require(['../components/index.vue'], resolve)
    },
    {
      path: '/case',
      name: '产品',
      component: resolve => require(['../components/case.vue'], resolve)
    },
    {
      path: '/scheme',
      name: '方案',
      component: resolve => require(['../components/scheme.vue'], resolve)
    },
    {
      path: '/natural',
      name: '资质',
      component: resolve => require(['../components/natural.vue'], resolve)
    },
    {
      path: '/about',
      name: '关于',
      component: resolve => require(['../components/about.vue'], resolve)
    },
    {
      path: '/board',
      name: '公告',
      component: resolve => require(['../components/board.vue'], resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js